import { ProjectTechnicalModule } from '@gp/enums/project';
import { TECHNICAL_MODULE_NAME_MAPPING } from '@gp/pages/Pipeline/ProjectDetails/Technical/const';

// value对应后端参数
export const PROJECTS_MAP = [
  {
    value: 'project',
    text: 'Project Name',
  },
  {
    value: 'platform',
    text: 'Platform',
  },
  // {
  //   value: 'priority',
  //   text: 'Priority',
  // },
  {
    value: 'business_owner',
    text: 'BO',
  },
  {
    value: 'pteam',
    text: 'P-team',
  },
  {
    value: 'studio',
    text: 'Studio',
  },
  // {
  //   value: 'form',
  //   text: 'Group',
  // },
  {
    value: 'next_checkpoint',
    text: 'Next Milestone',
  },
  {
    value: 'official_launch_date',
    text: 'Launch Date',
  },
  {
    value: 'updates_info',
    text: 'Project Updates',
  },
  {
    value: 'update_time',
    text: 'Update Time',
  },
  {
    value: 'status',
    text: 'Status',
  },
  {
    value: 'pps_comment',
    text: 'DPS Comment',
  },
];

export const PROJECT_DETAIL_MAP = [
  {
    value: 'genre',
    text: 'Genre',
  },
  {
    value: 'studio_location',
    text: 'Studio Location',
  },
  {
    value: 'current_size_of_team',
    text: 'Team Size',
  },
  {
    value: 'early_access',
    text: 'Early Access',
  },
  {
    value: 'publisher',
    text: 'Publishing Team',
  },
  {
    value: 'ip',
    text: 'IP',
  },
  {
    value: 'business_model',
    text: 'Business Model',
  },
  {
    value: 'current_milestone',
    text: 'Current Milestone',
  },
  // {
  //   value: 'form2',
  //   text: 'Developer',
  // },
  // {
  //   value: 'current_size_of_team',
  //   text: 'Current Headcount',
  // },
  // {
  //   value: 'expanded_genre',
  //   text: 'Expanded Genre',
  // },
  // {
  //   value: 'story_setting',
  //   text: 'Tagline',
  // },
  // {
  //   value: 'strategic_goal',
  //   text: 'Ambition',
  // },
];

export const LATEST_GR_MAP = [
  {
    value: 'review_result',
    text: 'Project Review Result',
  },
  {
    value: 'key_feedback',
    text: 'Key Feedback',
  },
  {
    value: 'action_items',
    text: 'Action Items',
  },
  {
    value: 'approved_budget_to_next',
    text: 'Approved Budget',
  },
];

export const STAKEHOLDER_MAP = [
  {
    value: 'pteam_contact',
    text: 'P-team Contact',
  },
  {
    value: 'finance_contact',
    text: 'Finance Contact',
  },
  {
    value: 'other_develop_owner',
    text: 'Other IEGG Development Project Owner',
  },
  {
    value: 'studio_develop_leader_team',
    text: 'Studio Development Leadership Team',
  },
];

export const TECHNICAL_MAP = [
  {
    value: ProjectTechnicalModule.Engine,
    text: TECHNICAL_MODULE_NAME_MAPPING[ProjectTechnicalModule.Engine],
  },
  {
    value: ProjectTechnicalModule.ServerProvider,
    text: TECHNICAL_MODULE_NAME_MAPPING[ProjectTechnicalModule.ServerProvider],
  },
  {
    value: ProjectTechnicalModule.ProgrammingLanguage,
    text: TECHNICAL_MODULE_NAME_MAPPING[ProjectTechnicalModule.ProgrammingLanguage],
  },
  {
    value: ProjectTechnicalModule.VersionControlSystem,
    text: TECHNICAL_MODULE_NAME_MAPPING[ProjectTechnicalModule.VersionControlSystem],
  },
  {
    value: ProjectTechnicalModule.AntiCheatSolution,
    text: TECHNICAL_MODULE_NAME_MAPPING[ProjectTechnicalModule.AntiCheatSolution],
  },
  {
    value: ProjectTechnicalModule.DatabaseAndDataService,
    text: TECHNICAL_MODULE_NAME_MAPPING[ProjectTechnicalModule.DatabaseAndDataService],
  },
];
